import * as React from 'react';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import mStyle from './OptionBox.module.scss';
import { JoinClassName } from '../../../utils/string';
import { LayoutProps } from '../../../constants';
import { FlexLayout } from '../../layout';
import { RadioBox } from '../RadioBox';
import { PublicStore } from '../../../stores';
import { t } from '../../../stores/TranslateStore';

export interface OptionItem {
  value: string | number; // key
  remark: string;
}

export interface OptionBoxActions extends LayoutProps {
  onChange: (selected: OptionItem) => any;
}

export interface OptionBoxProps extends OptionBoxActions {
  publicStore?: PublicStore;
  value: string | number;
  data: Array<OptionItem>;
  isDisabledTrackingStateChange?: boolean;
  isVertical?: boolean;
  readonly?: boolean;
  /**
   * remark 를 현재 언어로 번역할지 여부. 기본값 true.
   *
   * 선택지 라벨은 대부분 정적(매입/매출, 법인/개인 등)이라 번역 대상이지만,
   * data 를 레코드에서 동적으로 만드는 경우(고객·부서 목록 등)는
   * translate={false} 로 꺼야 한다 — 켜두면 그 값이 외부 모델로 나가고
   * 전 테넌트 공유 사전에 영구 저장된다.
   */
  translate?: boolean;
}

// observer: 번역이 도착하면 t.dict 가 바뀌므로 다시 그려야 한다.
@inject('publicStore')
@observer
export class OptionBox extends React.Component<OptionBoxProps> {
  @action
  callOnChange(value: OptionItem) {
    const { publicStore } = this.props;
    this.props.onChange && this.props.onChange(value);

    if (!this.props.isDisabledTrackingStateChange) {
      publicStore?.setStateChanged(true);
    }
  }

  render() {
    const {
      className,
      style,
      weight,
      size,
      value,
      data,
      onChange,
      translate = true,
    } = this.props;

    return (
      <FlexLayout
        elField={this.props.elField}
        className={JoinClassName.make([
          className,
          this.props.readonly ? mStyle.readonly : false,
        ])}
        weight={weight}
        size={size}
        style={style}
        isVertical={this.props.isVertical}
      >
        {data.map((item) => (
          <FlexLayout
            justify="center"
            align="center"
            key={item.value}
            elOption={`${item.value}`}
            className={JoinClassName.make([
              mStyle.item,
              item.value === value ? mStyle.active : false,
            ])}
            onClick={() => onChange(item)}
          >
            <RadioBox
              value={value === item.value}
            />
            <span>{translate ? t.T(item.remark) : item.remark}</span>
          </FlexLayout>
        ))}
      </FlexLayout>
    );
  }
}
